<template>
  <v-checkbox v-bind="attributes"
              v-on="listeners"
              :input-value="value"
              :error="hasFieldErrors"
              @change="$listeners.input"
              ref="proxy">
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"/>
    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </v-checkbox>
</template>

<script>
import InputMixin from '../mixins/input';

export default {
  mixins: [ InputMixin ],
  computed: {
    attributes () {
      let result = Object.assign({}, this.$attrs);
      this.mixinRequired(result);

      return result;
    },
    listeners () {
      const { input, ...rest } = this.$listeners;
      return rest;
    }
  }
};
</script>